import { Injectable } from '@angular/core';
import { CookieHelperService } from './cookie-helper.utils.service';

@Injectable({
  providedIn: 'root'
})
export class ExtendedCookieHelperUtilsService extends CookieHelperService {
  constructor() {
    super();
  }

  extractCookieValue(cookie: string | null, attributeToLookup: string) {
    if (cookie) {
      if (attributeToLookup.includes('.')) {
        const nestedAttributes = attributeToLookup.split('.');
        return this.getNestedAttributeValue(cookie, nestedAttributes);
      } else {
        return this.getAttributeValue(JSON.parse(cookie), attributeToLookup);
      }
    } else {
      return undefined;
    }
  }

  private getNestedAttributeValue(
    cookie: string,
    nestedAttributes: string[]
  ): unknown {
    const parsedCookie = JSON.parse(cookie);
    return nestedAttributes.reduce((parsedCookieObj, attribute, index, arr) => {
      if (index === arr.length - 1) {
        return this.getAttributeValue(parsedCookieObj, attribute);
      } else {
        const nestedAttributeValue = parsedCookieObj[attribute];
        nestedAttributes.splice(index, 1);
        return this.getNestedAttributeValue(
          JSON.stringify(nestedAttributeValue),
          nestedAttributes
        );
      }
    }, parsedCookie);
  }

  private getAttributeValue(cookie: Record<string, unknown>, attibute: string) {
    return cookie[attibute];
  }

  getTripType(): string | null {
    const prefCookie = this.getCookies('trip_type');
    return prefCookie?.split('=')?.[1]?.toLowerCase() || null;
  }

  getCookies = (cookieName: string): string => {
    const result = new RegExp(
      '(?:^|; )' + encodeURIComponent(cookieName) + '=([^;]*)'
    ).exec(document.cookie);
    if (this.isNewsFeed(cookieName)) {
      return result ? result[1] : '';
    } else {
      return result ? result[0].replace(/[.; ]+/g, '') : '';
    }
  };

  private isNewsFeed(cookieName: string): boolean {
    return (
      cookieName === 'newFeedAdvisoriesCountNumber' ||
      cookieName === 'lastVisitedFeedAdvisories'
    );
  }

  getMcCacheKey(): string | null {
    const prefCookie = this.getCookies('mc_cache_key');
    return prefCookie?.length > 0 ? prefCookie.split('=')?.[1] || null : null;
  }
}
